<template>
    <v-card class="rules-item">
        <v-btn class="rules-item__close-icon"
               @click="closeItem"
               absolute
               x-small
               fab
               top
               right
               color="secondary">
            <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="rules-item__row">
            <div class="rules-item__label">
                <div class="title__icon-container">
                    <v-img :src="require(`@/assets/img/icons/bio--white.svg`)" class="title__icon">
                    </v-img>
                </div>
                <p class="rules-item__title">Biography</p>
            </div>
            <div class="rules-item__select">
                <v-select
                        v-model="form.input.type"
                        :items="filterOptions"
                        label="Select rule"
                        :append-icon="'mdi-chevron-down'">
                    <template v-slot:selection="{ item }">
                        <span class="custom-value">
                            {{item.text}}
                        </span>
                    </template>
                </v-select>
            </div>
        </div>
        <RuleValue
                v-if="(form.input.type !== 'with-a-profile-picture') &&
                (form.input.type !== 'without-a-profile-picture')"
                v-model="form.input.value" :options="['any-of', 'all-of']">
        </RuleValue>
    </v-card>
</template>

<script>
    import RuleValue from "./RuleValue";

    export default {
        name: "Biographies",
        components: {RuleValue},
        props: ['uid', 'value'],
        data: () => ({
            form: {
                input:
                    {
                        value: null,
                        type: null
                    },
                type: "Biographies",
            },
            filterOptions: [
                {
                    text: 'contains',
                    value: 'contains',
                }, {
                    text: 'does not contain',
                    value: 'does-not-contain',
                }, {
                    text: 'with a profile picture',
                    value: 'with-a-profile-picture',
                }, {
                    text: 'without a profile picture',
                    value: 'without-a-profile-picture',
                }],
        }),
        mounted() {
            if (this.value) {
                this.form = this.value;
            }
        },
        methods: {
            closeItem: function () {
                this.$emit('itemClosed', this.uid)
            },
        },
        watch: {
            form: {
                handler: function (val, oldVal) {
                    this.$emit('input', val)
                },
                deep: true
            },
            value: {
                handler: function (val, oldVal) {
                    this.$emit('input', val)
                },
                deep: true
            }
        }
    }
</script>

<style scoped>

</style>
